import React, { useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction, loadAIDiagnosisQuestionAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setKeypadAction } from "../../../../redux/answeringQuestions/keypad";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";
import useLocalStorage from "../../../../hooks/useLocalStorage";

const Submitter = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const keypad = useSelector( state => state.keypad );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const loadAIDiagnosisQuestion = payload => { dispatch( loadAIDiagnosisQuestionAction( payload ) ) };
  const setKeypad = payload => { dispatch( setKeypadAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  const { setUserData } = useLocalStorage();

  useEffect( () => {
    setAnsweringQuestions( { isNextQuestion : true } );
  }, [ answeringQuestions.data.qstCd ] );

  const changeKeypad = () => {
    const isNotepad = TYPE.KEYPAD.NOTE === answeringQuestions.keypadType;
    const keypadType = isNotepad ? answeringQuestions.data.kypdTyCd : TYPE.KEYPAD.NOTE;
    setAnsweringQuestions( { keypadType } );
    setUserData( { isKeypad : isNotepad } );
  };

  const answering = () => {
    if ( answeringQuestions.answer.length === answeringQuestions.answer.filter( v => v?.indexOf( '\\phantom' ) === -1 ).length ) {
      loadAIDiagnosisQuestion( { progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE } );
    } else {
      setAnsweringQuestions( { isShowNotEnteredAnswerPopup : true } );
    }
    fadeTooltip();
  };

  const prevCursor = () => {
    const changedAnswerIndex = answeringQuestions.answerIndex - 1;
    setAnsweringQuestions( { answerIndex : 0 > changedAnswerIndex ? answeringQuestions.answer.length - 1 : changedAnswerIndex } );
    ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
    fadeTooltip();
  };

  const fadeTooltip = () => {
    if ( 1 === keypad.arrowKeyTooltipStatus ) {
      setKeypad( { arrowKeyTooltipStatus : 2 } );
      setTimeout( hideTooltip, 1000 );
    }
  };

  const hideTooltip = () => {
    setKeypad( { arrowKeyTooltipStatus : 0 } );
  };

  const nextCursor = () => {
    const changedAnswerIndex = answeringQuestions.answerIndex + 1;
    setAnsweringQuestions( { answerIndex : answeringQuestions.answer.length <= changedAnswerIndex ? 0 : changedAnswerIndex } );
    ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
    fadeTooltip();
  };

  return cloneElement( props.children || <Fragment />, {
    onChangeKeypad : changeKeypad,
    onAnswering : answering,
    onPrevCursor : prevCursor,
    onNextCursor : nextCursor,
    fadeTooltip: fadeTooltip,
  } );

};

export default Submitter;
